import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { modalActions } from '@/stores/action/widget.action';
import { useHistory } from 'react-router-dom';

function PopUp({ message, path, ModalActions }) {
    const history = useHistory();
    const handleClose = (e) => {
        if (e) e.preventDefault();
        ModalActions.showMessage({ show: false });
    };
    const handleNext = (e) => {
        if (e) e.preventDefault();
        ModalActions.showMessage({ show: false });
        path && history.push(path);
    };
    return (
        <div className="popup_01">
            <div className="popup_inner01">
                <div className="popup_inner01 text-center">
                    <img
                        src={require('@/resources/assets/images/close.png')}
                        className="popup_close"
                        alt="close"
                        onClick={handleClose}
                    />
                    <div className="join_btn_box text-center">
                        <ul className="mess">
                            {message.split('\n').map((line, index) => (
                                <li key={index}>{line}</li>
                            ))}
                        </ul>
                        <div className="sp20"></div>
                        <input type="button" className="btn04" value="확인" onClick={handleNext} />
                    </div>
                </div>
            </div>
        </div>
    );
}
export default connect(null, (dispatch) => ({
    ModalActions: bindActionCreators(modalActions, dispatch),
}))(PopUp);
